import {createRouter, createWebHashHistory} from 'vue-router'

import Login from "@/pages/Login"
import Register from "@/components/Register.vue"
import  index from "@/pages/index/index.vue"
import SentenceData from "@/pages/SentenceData"
import PictureDetail from "@/pages/PictureDetail"



const routes = [
    {
        path: '/',
        name: 'index',
        component: index
    },
    {
        path: '/home',
        name: '首页',
        component: () => import('../pages/layout/index'),
        redirect: '/home',
        children: [
            {
                path: '/home',
                name: '首页',
                component: () => import('../pages/Home/index'),
            },
            {
                path: '/sentencepair',
                name: '句对',
                component: () => import('../pages/SentencePair/index'),
            },
            // {
            //     path: '/dictionary',
            //     name: '词典',
            //     component: () => import('../pages/Dictionary/index'),
            // },
            {
                path: '/picture',
                name: '图片',
                component: () => import('../pages/Picture/index'),
            },
            {
                path: '/fileupload',
                name: '文件',
                component: () => import('../pages/FileUpload/index'),
            },
            {
                path: '/coretermst',
                name: '核心词',
                component: () => import('../pages/CoreTermsT/index'),
            },

            {
                path: '/diplomaticspeech',
                name: '外交对话',
                component: () => import('../pages/DiplomaticSpeech/index'),
            },
            {
                path: '/mediareport',
                name: '媒体报道',
                component: () => import('../pages/MediaReport/index'),
            },
            // {
            //     path: '/reportalignment',
            //     name: '英汉平行中国共产党报告',
            //     component: () => import('../pages/ReportAlignment/index'),
            // },

            {
                path: '/xjpspeech',
                name: '英汉平行习近平外交华话语',
                component: () => import('../pages/XJPSpeech/index'),
            },
            {
                path: '/dictionarynew',
                name: '词典',
                component: () => import('../pages/DictionaryNew/index'),
            },
            {
                path: '/govermentjob',
                name: '英汉平行中国政府工作报告',
                component: () => import('../pages/GovermentJob/index'),
            },
            {
                path: '/cpcnc',
                name: '英汉平行中国共产党报告',
                component: () => import('../pages/CPCNC/index'),
            },
            {
                path: '/soundfrequency',
                name: '中国外交话语音频库',
                component: () => import('../pages/SoundFrequency/index'),
            },
            {
                path: '/xiaoyu',
                name: '小豫',
                component: () => import('../pages/XiaoYu/index'),
            },
        ]
    },
    {
        path: "/login",
        name: 'login',
        component: Login,
    },
    {
        path: "/register",
        name: 'register',
        component: Register,
        meta: {show: false}
    },
    {
        path: "/sentencedata",
        name: '句对数据',
        component: SentenceData,
    },
    {
        path: "/picturedetail",
        name: '图片详情',
        component: PictureDetail,
    }
    // {
    //     path: "/xiaoyunew",
    //     name: 'xiaoyunew',
    //     component: XiaoYuNew,
    // },
   
]

const router = createRouter({
    history: createWebHashHistory(),
    mode: 'history',
    base: '/english/',
    routes
})

export default router
